import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import './HomeCarousel.css';

import imgChecking from '../../assets/images/Home2.png';
import imgSavings from '../../assets/images/saving.png';
import imgMobile from '../../assets/images/retailchecking.png';

const Slide = ({ title, subtitle, imageSrc, primaryLabel, primaryHref, secondaryLabel, secondaryHref }) => (
  <div className="home-hero">
    <div className="gn-container">
      <div className="home-hero__grid">
        <div className="home-hero__copy">
          <h1 className="home-hero__title">{title}</h1>
          <p className="home-hero__subtitle">{subtitle}</p>
          <div className="home-hero__ctas">
            {primaryLabel && <a className="btn btn-gn-primary" href={primaryHref}>{primaryLabel}</a>}
            {secondaryLabel && secondaryHref && <a className="btn btn-gn-secondary" href={secondaryHref}>{secondaryLabel}</a>}
          </div>
        </div>
        <div className="home-hero__image home-hero__image--tilt">
          <img src={imageSrc} alt="" />
        </div>
      </div>
    </div>
  </div>
);

const HomeCarousel = () => {
  return (
    <section className="home-carousel section-lg">
      <Swiper
        modules={[Autoplay, Pagination, EffectFade]}
        effect="fade"
        loop
        speed={900}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
      >
        {/* <SwiperSlide>
          <Slide
            title="The #1 most loved banking app"
            subtitle="Simple, transparent banking with the GN Bank team you trust."
            imageSrc={imgMobile}
            primaryLabel="Open an account"
            primaryHref="/checking"
            secondaryLabel="Get the app"
            secondaryHref="/download"
          />
        </SwiperSlide> */}

<SwiperSlide>
          <Slide
            title="The Best Community Bank in Chicago"
            subtitle="Community banking that puts you first. We're here to help you achieve your financial goals."
            imageSrc={imgChecking}
            primaryLabel="Open checking"
            primaryHref="/checking"
            secondaryLabel="Get Started"
            secondaryHref="/OnlineBanking"
          />
        </SwiperSlide>
        <SwiperSlide>
          <Slide
            title="Retail Checking"
            subtitle="Mobile and online banking. Get paid faster with direct deposit."
            imageSrc={imgMobile}
            primaryLabel="Open checking"
            primaryHref="/checking"
            secondaryLabel="Learn more"
            secondaryHref="/OnlineBanking"
          />
        </SwiperSlide>
        <SwiperSlide>
          <Slide
            title="High‑yield savings, made simple"
            subtitle="Grow automatically with transfers and round‑ups."
            imageSrc={imgSavings}
            primaryLabel="Start saving"
            primaryHref="/savings"
            secondaryLabel="See rates"
            secondaryHref="/cd"
          />
        </SwiperSlide>
      </Swiper>
    </section>
  );
};

export default HomeCarousel;


